import React from 'react';
import { Route, Switch } from 'react-router-dom';

import { Routes } from '../../routes';

import MyCards from './screens/MyCards';
import ArchivedCards from './screens/ArchivedCards';
import MyCardDetails from './screens/MyCardDetails';

export const WalletRoutes = () => (
    <Switch>
        <Route path={Routes.WalletMyCards} exact component={MyCards} />
        <Route path={Routes.WalletArchivedCards} exact component={ArchivedCards} />
        <Route path={Routes.WalletMyCardDetails} exact component={MyCardDetails} />
    </Switch>
);
